import { useContext } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@utilities-one/gpm-ui';

import type { SelectOption } from '@/library/form/types/form.type';
import { OptionalPortalContainerContext } from '@/library/portal/OptionalPortalContainerContext';

interface PortalAwareSelectProps {
  options: SelectOption[];
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  'aria-label': string;
}

/**
 * Single-value select whose list portals into the enclosing dialog or sheet when there is one
 * (`OptionalPortalContainerContext`), and into the default portal elsewhere.
 */
export const PortalAwareSelect = ({
  options,
  value,
  onValueChange,
  placeholder,
  disabled,
  className,
  'aria-label': ariaLabel,
}: PortalAwareSelectProps) => {
  const portalHostEl = useContext(OptionalPortalContainerContext);

  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className={className} aria-label={ariaLabel}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent {...(portalHostEl ? { portalContainer: portalHostEl, position: 'popper' as const } : {})}>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
